export function getAllMatchesResolved(cards, getReasonsByRef) {
  if (!Array.isArray(cards) || cards.length === 0) return false;

  return cards.every((c) => {
    const reasons = getReasonsByRef?.(c?.ref);
    return (
      Array.isArray(reasons) &&
      reasons.some((r) => String(r ?? "").trim().length > 0)
    );
  });
}

export function anyMatchIsMyClient(
  cards,
  getReasonsByRef,
  myClientReasons = []
) {
  if (!Array.isArray(cards) || cards.length === 0) return false;
  if (!Array.isArray(myClientReasons) || myClientReasons.length === 0)
    return false;

  const normalizedMyClient = myClientReasons
    .map((r) =>
      String(r ?? "")
        .trim()
        .toLowerCase()
    )
    .filter(Boolean);

  return cards.some((c) => {
    const reasons = getReasonsByRef?.(c?.ref);
    if (!Array.isArray(reasons)) return false;

    return reasons
      .map((r) =>
        String(r ?? "")
          .trim()
          .toLowerCase()
      )
      .filter(Boolean)
      .some((r) => normalizedMyClient.includes(r));
  });
}
